<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Modification de la pièce <strong>{{typepiece.libelle}}</strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="libelle">Pièces</label>
              <b-form-input type="text" v-model="typepiece.libelle" placeholder="Type de la pièce..."></b-form-input>
            </b-col>
           
          </b-row>
         
          
          <div slot="footer">
            <span v-if="can('typepiece-edit')"><b-button type="submit" size="sm" variant="primary" @click.prevent="put()"><i class="fa fa-dot-circle-o"></i> Modifier</b-button></span>
            <b-button type="reset" size="sm" @click="goBack" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      options : [],
      typepiece:{
          libelle: '',
          _method: 'PUT'
      }
    }
  },
  methods:{
    goBack() {
        this.$router.go(-1)
      },
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    async put(){  
      let data = {
        libelle:this.$route.params.libelle,
        typepiece:this.typepiece
      }   
      this.response =await this.$store.dispatch('typepiece/put_typepiece',data)
      this.showAlert()
    },
    async displayTypePiece(){
        
        let response = await this.$store.dispatch('typepiece/show_typepiece',this.$route.params.libelle)
        this.typepiece.libelle= response.libelle
    },
    get_all_typepieces(){
          return this.rows =  store.getters['typepiece/rows'];
    },
    can(perm){
      return store.getters['auth/can'](perm)
    },
    reset(){
        this.typepiece.libelle= ''
    }
  },
  mounted(){
      this.displayTypePiece()
  }
}
</script>
